import {
    PASSWORD_INVALID,
} from "../constants";
import IError from "../interfaces/IError";

export default function validatePassword(password: string): IError[] {
    const errors: IError[] = [];
    const MIN_PASSWORD_LENGTH = 8;
    const NUMBER_REGEX = /[0-9]/;
    const LETTER_REGEX = /[a-z]/i;

    if (
        password.length < MIN_PASSWORD_LENGTH ||
        !NUMBER_REGEX.test(password) ||
        !LETTER_REGEX.test(password)
    ) {
        errors.push({
            data: {
                minLength: MIN_PASSWORD_LENGTH,
            },
            type: PASSWORD_INVALID,
        });
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/utils/validatePassword.ts